<template>
    <div>
        <table width="100%">
            <thead>
            <tr>
                <th>Service Name</th>
                <th>Product ID</th>
                <th>Active Partner Agents</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="service in services">
                    <td>{{ service.name }}</td>
                    <td>{{ service.site_id }}</td>
                    <td>{{ service.useragents_count }}</td>
                    <td><a :href="'/admin/services/' + service.id + '/edit'">Edit</a></td>
                </tr>
                <tr>
                    <td><a :href="'/admin/services/create?client=' + client">Add Service(s)</a></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "ManageClientServices",
    props: {
        client: Number,
    },
    data() {
        return {
            services: [],
        }
    },
    beforeMount() {
        this.getServices();
    },
    methods: {
        getServices: function() {
            axios.post('/admin/services/' + this.client)
                .then(response => {
                    this.services = response.data;
                })
        }
    }
}
</script>

<style scoped>

</style>
